<template>
    <div
        class="month-budget-form block-max-xs"
        :class="{
            'month-budget-form_mobile': isMobile
        }"
    >
        <btns-nav
            v-if="isMobile"
            :items="getBtns"
            class="mb-4"
        ></btns-nav>
        <v-btn-toggle
            v-if="isNew"
            v-model="tab"
            mandatory
            class="my-toggle day-assistant__toggle"
        >
            <v-btn
                color="primary"
                key="weekly-plan"
                elevation="0"
            >{{ $t('msg.add') }}<br>{{ $t('msg.oneRecord') }}</v-btn>
            <v-btn
                color="primary"
                key="projects"
                elevation="0"
            >{{ $t('msg.transferFrom') }}<br>{{ $t('msg.otherMonth') }}</v-btn>
        </v-btn-toggle>
        <div
            :class="{
                'pt-4': isNew,
            }"
        >
            <form-single
                v-if="tab === 0"
                :month="month"
            ></form-single>
            <form-from-other-month
                v-if="tab === 1"
                :month="month"
            ></form-from-other-month>
        </div>
    </div>
</template>

<script>
import FormSingle from "../../../components/block/Finance/MonthPlan/FormSingle";
import FormFromOtherMonth from "../../../components/block/Finance/MonthPlan/FormFromOtherMonth";
import BtnsNav from "../../../components/ui/BtnsNav";

export default {
    components: {FormSingle, FormFromOtherMonth, BtnsNav},
    data() {
        return {
            isNew: true,
            tab: 0,
            month: null
        };
    },
    computed: {
        getBtns() {
            return [
                {
                    label: this.$t('msg.toMonthlyBudget'),
                    to: {name: 'month_budget', query: {month: this.month}},
                    type: 'back'
                },
            ];
        }
    },
    created() {
        this.month = this.$route.query.month;

        this.isNew = this.$route.name === 'create_month_budget';

        let item = {id: 1, to: {query: {month: this.month}}};

        if (!this.isNew) {
            this.$store.commit('setBreadcrumbs', [item, {id: 2, name: this.month}]);
        } else {
            this.$store.commit('setBreadcrumbs', [item])
        }
    }
}
</script>

<style lang="scss">
.month-budget-form {
    &.month-budget-form_mobile {
        .v-btn__content {
            font-size: 11px;
        }
    }
}
</style>